(function (ws) {
    'use strict';
    ws.views.carousel = Backbone.View.extend({

        events: {
            'click .btnPrevious': 'previousClick',
            'click .btnNext': 'nextClick'
        },

        initialize () {
            this.$viewPort = this.$('.viewport');
            this.$paginationPoints = this.$('.pagination-points');
            this.$ulList = this.$viewPort.find('.list');
            this.canClick = true;
            this.$first = this.$ulList.children(':first');
            this.$last = this.$ulList.children(':last');
            this.$arrows = this.$('.arrow');
            this.itemPerMove = 3;
            this.distance = Math.max(this.$first.outerWidth(true), this.$last.outerWidth(true)) * this.itemPerMove;
            this.duration = 1000;
            this.animateNextMovement = {scrollLeft: '+=' + this.distance};
            this.animatePrevMovement = {scrollLeft: '-=' + this.distance};
            this.currentStep = 1;
            this.lastStep = Math.ceil(this.$ulList.find('li').length / this.itemPerMove);
            this.$btnPrevious = this.$('.btnPrevious');
            this.$btnNext = this.$('.btnNext');
            this.createPaginationPoints();
            this.setUlWidth();
            this.checkArrows();
        },

        /**
         * Set width for ul element depends on the li quantity
         */
        setUlWidth () {
            const width = (parseInt(this.$first.css('width')) + parseInt(this.$first.css('margin-right')) + parseInt(this.$first.css('margin-left'))) * this.$ulList.find('li').length;
            this.$ulList.width(width);
        },

        /**
         * Create pagination points
         */
        createPaginationPoints() {
            const paginationPoints = Math.ceil(this.$ulList.find('li').length / this.itemPerMove);
            for (i = 0; i < paginationPoints; i++) {
                if (i === 0) {
                    this.$paginationPoints.append('<li class="dot current"></li>');
                } else {
                    this.$paginationPoints.append('<li class="dot"></li>');
                }
            }
        },

        /**
         * If number of elements if less than items per move we have to hide arrows.
         */
        checkArrows () {
            this.$arrows.toggle(this.$ulList.find('li').length > this.itemPerMove);
        },

        /**
         * Go to the next pagination item
         */
        nextPaginationItem () {
            const nextElement = this.$('.dot.current').next();
            this.$('.dot.current').removeClass('current');
            if (nextElement.length === 1) {
                nextElement.addClass('current');
            } else {
                this.$('.dot').first().addClass('current');
            }
        },

        /**
         * Go to the previous pagination item
         */
        previousPaginationItem () {
            const prevElement = this.$('.dot.current').prev();
            this.$('.dot.current').removeClass('current');
            if (prevElement.length === 1) {
                prevElement.addClass('current');
            } else {
                this.$('.dot').last().addClass('current');
            }
        },

        /**
         * Check if there is more items than item per move
         */
        canPaginate () {
            return this.$ulList.find('li').length > this.itemPerMove;
        },

        /**
         * Go to the next element
         * @returns {boolean}
         */
        nextClick () {
            if (!this.canClick || !this.canPaginate()) {
                return false;
            }

            this.canClick = false;
            const _this = this;
            this.nextPaginationItem();

            this.$viewPort.stop().animate(this.animateNextMovement, {
                duration: this.duration,
                complete: function () {
                    _this.$viewPort.scrollLeft(0);
                    for (i = 0; i < _this.itemPerMove; i++) {
                        _this.$ulList.children(':last').after(_this.$ulList.children(':first'));
                    }

                    _this.currentStep++;
                    if (_this.currentStep > 1) {
                        _this.$btnPrevious.removeClass('hide');
                    }

                    if (_this.currentStep === _this.lastStep) {
                        _this.$btnNext.addClass('hide');
                    }

                    _this.canClick = true;
                }
            });
        },

        /**
         * Go to the previous element
         * @returns {boolean}
         */
        previousClick () {
            if (!this.canClick || !this.canPaginate()) {
                return false;
            }

            this.previousPaginationItem();
            this.canClick = false;
            const _this = this;
            for (i = 0; i < this.itemPerMove; i++) {
                this.$ulList.prepend(this.$ulList.children(':last'));
            }

            this.$viewPort.scrollLeft(this.distance);
            this.$viewPort.stop().animate(this.animatePrevMovement, {
                duration: this.duration,
                complete: function() {
                    _this.currentStep--;
                    if (_this.currentStep === 1) {
                        _this.$btnPrevious.addClass('hide');
                    }

                    if (_this.currentStep < _this.lastStep) {
                        _this.$btnNext.removeClass('hide');
                    }

                    _this.canClick = true;
                }
            });
        }
    });
})(westcon);
